import React from 'react';
import { Grid } from 'styled-css-grid';

import Modal from '@xcritical/modal';

import { NOTIFICATION_TYPES } from '../../consts';
import { INotificationDetailsProps } from '../notification-actions/types';

// -- APPEND IMPORT NOTIFICATION DETAILS HERE --
import { EconomicProfileChangedDetails } from './EconomicProfileChangedDetails';
import { AppropriatenessTestPassedDetails } from './AppropriatenessTestPassedDetails';
import { DepositDetails } from './DepositDetails';
import { DepositAttemptDetails } from './DepositAttemptDetails';
import { WithdrawRequestDetails } from './WithdrawRequestDetails';
import { WithdrawRequestAttemptDetails } from './WithdrawRequestAttemptDetails';
import { CalendarEventDetails } from './CalendarEventDetails';
import { NewLeadsForSalesDetails } from './NewLeadsForSalesDetails';
import { NewLeadsForTeamManagersDetails } from './NewLeadsForTeamManagersDetails';
import { ClosePnlToBalanceLimitExceededDetails } from './ClosePnlToBalanceLimitExceededDetails';
import { CriticalEquityExceededDetails } from './CriticalEquityExceededDetails';
import { CriticalOpenPnlSumExceededDetails } from './CriticalOpenPnlSumExceededDetails';
import { DocumentUploadedDetails } from './DocumentUploadedDetails';
import { LeadActionDetails } from './LeadActionDetails';
import { ExpiringDealsDetails } from './ExpiringDealsDetails';
import { ExpiringDealsForTMDetails } from './ExpiringDealsForTMDetails';
import { NewLeadDuplicateByPhoneDetails } from './NewLeadDuplicateByPhoneDetails';
import { UnprocessedWithdrawRequestDetails } from './UnprocessedWithdrawRequestDetails';
import { ClientChangedPersonalDataDetails } from './ClientChangedPersonalDataDetails';
import { IdentityDocumentExpiresDetails } from './IdentityDocumentExpiresDetails';
import { TotalDepositLimitExceededDetails } from './TotalDepositLimitExceededDetails';
import { NewLeadDepositCardUsedDetails } from './NewLeadDepositCardUsedDetails';
import { NewDepositPaymentMethodDetails } from './NewDepositPaymentMethodDetails';
import { VideoVerificationRequestedDetails } from './VideoVerificationRequestedDetails';
import { DormantClientDetails } from './DormantClientDetails';
import { RefillDemoAccountAttempt } from './RefillDemoAccountAttempt';

export const NotificationDetails: React.FC<INotificationDetailsProps> = ({
  isOpen,
  notificationItem,
  onCancel,
}) => (
  <Modal
    name="notificationDetails"
    title="Notification Details"
    isOpen={isOpen}
    onModalCancel={onCancel}>
    <Grid columns="140px 1fr" minRowHeight="0px">
      {
        {
          // -- APPEND NOTIFICATION DETAILS HERE --
          [NOTIFICATION_TYPES.EconomicProfileChanged]: (
            <EconomicProfileChangedDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.AppropriatenessTestPassed]: (
            <AppropriatenessTestPassedDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.Deposit]: (
            <DepositDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.DepositAttempt]: (
            <DepositAttemptDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.WithdrawRequest]: (
            <WithdrawRequestDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.WithdrawRequestAttempt]: (
            <WithdrawRequestAttemptDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.CalendarEvent]: (
            <CalendarEventDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.NewLeadsForSales]: (
            <NewLeadsForSalesDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.NewLeadsForTeamManagers]: (
            <NewLeadsForTeamManagersDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.ClosePnlToBalanceLimitExceeded]: (
            <ClosePnlToBalanceLimitExceededDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.CriticalEquityExceeded]: (
            <CriticalEquityExceededDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.CriticalOpenPnlSumExceeded]: (
            <CriticalOpenPnlSumExceededDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.DocumentUploaded]: (
            <DocumentUploadedDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.LeadAction]: (
            <LeadActionDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.ExpiringDeals]: (
            <ExpiringDealsDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.ExpiringDealsForTeamManagers]: (
            <ExpiringDealsForTMDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.NewLeadDuplicateByPhone]: (
            <NewLeadDuplicateByPhoneDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.UnprocessedWithdrawRequest]: (
            <UnprocessedWithdrawRequestDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.ClientChangedPersonalData]: (
            <ClientChangedPersonalDataDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.IdentityDocumentExpires]: (
            <IdentityDocumentExpiresDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.TotalDepositLimitExceeded]: (
            <TotalDepositLimitExceededDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.NewLeadDepositCardUsed]: (
            <NewLeadDepositCardUsedDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.NewDepositPaymentMethod]: (
            <NewDepositPaymentMethodDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.VideoVerificationRequested]: (
            <VideoVerificationRequestedDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.DormantClient]: (
            <DormantClientDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.DormantClientRestoreActive]: (
            <DormantClientDetails {...notificationItem} />
          ),
          [NOTIFICATION_TYPES.RefillDemoAccountAttempt]: (
            <RefillDemoAccountAttempt {...notificationItem} />
          ),
        }[notificationItem.notificationDetails.notificationType]
      }
    </Grid>
  </Modal>
);
